import { motion } from "framer-motion";

// Shared monumental, tactical page hero used across public pages.
// title/subtitle accept nodes so pages can color a word red.
export const PageHero = ({ kicker, title, subtitle, image, imageAlt = "", children }) => (
  <section className="relative pt-40 pb-24 grain stars tactical-grid overflow-hidden bg-[#0A1128]">
    {image && (
      <img src={image} alt={imageAlt} className="absolute inset-0 w-full h-full object-cover opacity-40" />
    )}
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A1128] via-[#0A1128]/90 to-[#0A1128]/60" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-transparent to-[#0A1128]/40" />
    <div className="absolute top-1/4 -left-40 w-[560px] h-[560px] glow-red pointer-events-none" />
    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
      <div className="border-l-2 border-[#D90429] pl-6 sm:pl-8">
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="mb-5">
          <span className="kicker-pill">{kicker}</span>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}
          className="font-display text-5xl sm:text-7xl uppercase text-white leading-[0.9] max-w-4xl drop-shadow-[0_2px_20px_rgba(0,0,0,0.55)]"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }}
            className="text-white/75 text-lg max-w-2xl mt-6 leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </div>
    <div className="absolute bottom-0 left-0 right-0 h-1.5 chevron-accent opacity-80" />
  </section>
);
